import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Faq from '../components/Faq/Faq';

const FaqPage = () =>{
    return(
        <>
        <Navbar />
        <Faq />
        <Footer />        
        </>
    )
}
export default FaqPage;